import React, { useState } from "react";
import logo from "../white-logo.png";
import backLogo from "../black-logo.png";
import defaultAvatar from '../user.png';
import { Button, Card, Col, Container, FloatingLabel, Form, Nav, ProgressBar, Row, Table } from "react-bootstrap";
import BasicRegForm from "../components/registration/BasicRegForm";
import { BsArchive, BsBuilding, BsBuildingFill, BsBuildingFillAdd, BsBuildingsFill, BsChevronLeft, BsFillFileEarmarkTextFill } from 'react-icons/bs';
import { MdDashboard } from "react-icons/md";
import { FaArchive, FaBell, FaCloudDownloadAlt, FaExchangeAlt, FaExpandAlt } from "react-icons/fa";
import { BiCog, BiSupport } from "react-icons/bi";
import { CgSidebar, CgSidebarOpen } from "react-icons/cg";
import { useAuthState } from "../context/AuthContext";
import EnergoCard from "../components/shared/EnergoCard";


const CameraPage = () => {

    const { user } = useAuthState();
    const [sidebarExpanded, setSidebarExpanded] = useState(true);

    return (
        <div className="vh-100" style={{ backgroundColor: "#3b4239", color: "white", backgroundImage: `url(${backLogo})`, backgroundRepeat: "no-repeat", backgroundPosition: "center" }}>
            <Nav
                className={`d-none d-md-block sidebar ${sidebarExpanded ? "text-start" : "text-center"}`}
                style={sidebarExpanded ? { width: "250px" } : { width: "100px" }}
            >
                <img src={logo} alt="" className="img-fluid" />
                <Nav.Link onClick={() => setSidebarExpanded(!sidebarExpanded)} className="mt-5 text-center">
                    {sidebarExpanded ?
                        <CgSidebar className="text-light" size={30} />
                        :
                        <CgSidebarOpen className="text-light" size={30} />
                    }
                </Nav.Link>
                <div className="sidebar-center">
                    <Nav.Link className="text-light">
                        <MdDashboard size={30} /> <span hidden={!sidebarExpanded}>Dashboard</span>
                    </Nav.Link>
                    <Nav.Link className="text-light">
                        <BsBuildingsFill size={30} /> <span hidden={!sidebarExpanded}>Verwaltete Gebäude</span>
                    </Nav.Link>
                    <Nav.Link className="text-light">
                        <BsFillFileEarmarkTextFill size={30} /> <span hidden={!sidebarExpanded}>Energielieferverträge</span>
                    </Nav.Link>
                    <Nav.Link className="text-light">
                        <FaCloudDownloadAlt size={30} /> <span hidden={!sidebarExpanded}>Downloadbereich</span>
                    </Nav.Link>
                    <Nav.Link className="text-light">
                        <FaArchive size={30} /> <span hidden={!sidebarExpanded}>Archiv</span>
                    </Nav.Link>
                    <Nav.Link className="text-light">
                        <BiSupport size={30} /> <span hidden={!sidebarExpanded}>Support</span>
                    </Nav.Link>
                </div>
                <div className="sidebar-bottom" style={sidebarExpanded ? { width: "250px" } : { width: "100px" }}>
                    <Nav.Item>
                        <div
                            className="avatar-image"
                            style={{
                                backgroundImage: `url(${user?.image_1920 && user.image_1920 !== "False" ? 'data:image/*;base64,' + user.image_1920 : defaultAvatar})`,
                                backgroundSize: 'contain',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat'
                            }}
                        >
                        </div>
                    </Nav.Item>
                    <Nav.Link className="text-light">
                        <FaBell size={30} /> <span hidden={!sidebarExpanded}>Benachrichtigungen</span>
                    </Nav.Link>
                    <Nav.Link className="text-light">
                        <BiCog size={30} /> <span hidden={!sidebarExpanded}>Einstellungen</span>
                    </Nav.Link>
                </div>
            </Nav>
            <div className="none-sidebar-area" style={sidebarExpanded ? { marginLeft: "250px" } : { marginLeft: "100px" }}>
                <h2 style={{ fontWeight: 700 }} className="text-energo">ENERGO Management Portal</h2>
                <Row>
                    <Col xl="3" className="mt-5">
                        <p><b>Energielieferverträge</b></p>
                        <h1 style={{ fontSize: "50px" }}>7.300</h1>
                        <ProgressBar>
                            <ProgressBar animated variant="energo" now={35} key={1} />
                            <ProgressBar animated variant="secondary" now={35} key={2} />
                            <ProgressBar animated variant="warning" now={30} key={3} />
                        </ProgressBar>
                        <Table className="mt-3 text-white" variant="transparent">
                            <tbody>
                                <tr>
                                    <td><div style={{ width: "10px", height: "10px", borderRadius: "10px", background: "#a2c13f", marginTop: "7px" }}></div> </td>
                                    <td>Aktive Energielieferverträge</td>
                                    <td>2555</td>
                                    <td><b>35%</b></td>
                                </tr>
                                <tr>
                                    <td><div className="bg-secondary" style={{ width: "10px", height: "10px", borderRadius: "10px", marginTop: "7px" }}></div> </td>
                                    <td>Energielieferverträge im Leerstand</td>
                                    <td>2555</td>
                                    <td><b>35%</b></td>
                                </tr>
                                <tr>
                                    <td><div className="bg-warning" style={{ width: "10px", height: "10px", borderRadius: "10px", marginTop: "7px" }}></div> </td>
                                    <td>Beendete Energielieferverträge</td>
                                    <td>2190</td>
                                    <td><b>30%</b></td>
                                </tr>
                                <tr>
                                    <td colSpan={4} className="text-end" style={{ borderBottom: 0 }}>
                                        <a href="#" className="link-energo">ansehen</a>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                    <Col xl="6">
                        <Card style={{ borderRadius: "25px", width: "500px", marginLeft: "auto", marginRight: "auto" }} className="bg-violet text-white pulse">
                            <Card.Body>
                                <Row className="align-items-center">
                                    <Col xl="4">
                                        <FaCloudDownloadAlt size={80} />
                                    </Col>
                                    <Col xl="8">
                                        <p><b>Neue Dokumente sind für Sie für Download bereit</b></p>
                                        <p className="text-end">Zum Downloadbereich</p>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xl="3">
                        <p><b>Schnellfunktionen</b></p>
                        <p>
                            <a href="#" className="link-energo">
                                <div style={{ backgroundColor: "#a2c13f", padding: "15px", borderRadius: "15px", color: "#fff!important", display: "inline-block" }}>
                                    <BsBuildingFillAdd className="text-white" size={30} />
                                </div>
                                &nbsp; Neues MEG/WEG
                            </a>
                        </p>
                        <p>
                            <a href="#" className="link-energo">
                                <div style={{ backgroundColor: "#a2c13f", padding: "15px", borderRadius: "15px", color: "#fff!important", display: "inline-block" }}>
                                    <BiSupport className="text-white" size={30} />
                                </div>
                                &nbsp; Neues Support Ticket erstellen
                            </a>
                        </p>
                        <p>
                            <a href="#" className="link-energo">
                                <div style={{ backgroundColor: "#a2c13f", padding: "15px", borderRadius: "15px", color: "#fff!important", display: "inline-block" }}>
                                    <FaExchangeAlt className="text-white" size={30} />
                                </div>
                                &nbsp; Hausverwaltungswechsel
                            </a>
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col xl="3" style={{ marginTop: "200px" }}>
                        <b>Verwaltete Gebäude</b>
                        <h1 style={{ fontSize: "50px" }}>700</h1>
                        <Table className="text-white text-start">
                            <tbody>
                                <tr>
                                    <td>Wien</td>
                                    <td>200</td>
                                    <td><b>30%</b></td>
                                </tr>
                                <tr>
                                    <td>Burgenland</td>
                                    <td>200</td>
                                    <td><b>30%</b></td>
                                </tr>
                                <tr>
                                    <td>Kärnten</td>
                                    <td>200</td>
                                    <td><b>30%</b></td>
                                </tr>
                                <tr>
                                    <td>Steiermark</td>
                                    <td>200</td>
                                    <td><b>30%</b></td>
                                </tr>
                                <tr>
                                    <td>Niederösterreich</td>
                                    <td>200</td>
                                    <td><b>30%</b></td>
                                </tr>
                                <tr>
                                    <td>Oberösterreich</td>
                                    <td>200</td>
                                    <td><b>30%</b></td>
                                </tr>
                                <tr>
                                    <td>Salzburg</td>
                                    <td>200</td>
                                    <td><b>30%</b></td>
                                </tr>
                                <tr>
                                    <td>Tirol</td>
                                    <td>200</td>
                                    <td><b>30%</b></td>
                                </tr>
                                <tr>
                                    <td>Vorarlberg</td>
                                    <td>200</td>
                                    <td><b>30%</b></td>
                                </tr>
                                <tr>
                                    <td colSpan={3} className="text-end" style={{ borderBottom: 0 }}>
                                        <a href="#" className="link-energo">ansehen</a>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                    <Col xl="3">
                    </Col>
                    <Col xl="3"></Col>
                    <Col xl="3">
                        <p><b>Lezte Tickets</b></p>
                        <Table variant="transparent" className="text-white">
                            <tbody>
                                <tr>
                                    <td>Ticket Titel 1</td>
                                    <td>22.03.2024</td>
                                    <td><a href="#" className="link-energo">ansehen</a></td>
                                </tr>
                                <tr>
                                    <td>Ticket Titel 1</td>
                                    <td>22.03.2024</td>
                                    <td><a href="#" className="link-energo">ansehen</a></td>
                                </tr>
                                <tr>
                                    <td>Ticket Titel 1</td>
                                    <td>22.03.2024</td>
                                    <td><a href="#" className="link-energo">ansehen</a></td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default CameraPage;